// Clickable column header for a ledger-style admin table. Extracted from
// admin/src/pages/AllProformasPage.jsx's original local SortHeader — a
// plain <button> inside a <th>, no chrome, so the header still reads as a
// header and not a control (admin/CLAUDE.md: hand-roll, no data-grid
// library). Pairs with shared/hooks/useSortableList.js.
//
// `label` is a string the caller has already run through its own t() — this
// component holds no i18n of its own, every page using it supplies its own
// Amharic/English pair via shared/i18n/admin.js (root CLAUDE.md: no
// hardcoded English in a component).
//
// `align` ('left' | 'right') only affects text-align on the <th> itself —
// used by columns like a money total that read right-aligned elsewhere in
// this app. `thClassName` lets a caller merge in a page-local class (e.g.
// ApprovalQueuePage's totalHeader) alongside this component's own styling.

import styles from './SortHeader.module.css';

export function SortHeader({
  column,
  label,
  sortCol,
  sortDir,
  onSort,
  align = 'left',
  thClassName,
}) {
  const active = sortCol === column;
  const thClasses = [align === 'right' ? styles.right : null, thClassName]
    .filter(Boolean)
    .join(' ');
  return (
    <th className={thClasses || undefined}>
      <button
        type="button"
        className={`${styles.sortButton} ${active ? styles.sortActive : ''}`}
        onClick={() => onSort(column)}
      >
        {label}
        <span className={styles.sortArrow} aria-hidden="true">
          {active ? (sortDir === 'asc' ? '▲' : '▼') : '↕'}
        </span>
      </button>
    </th>
  );
}

export default SortHeader;
